import { useReference } from '@/lib/queries';
import { currentLanguage, t } from '@/lib/i18n';
import { countryName } from '@/lib/format';
import { Select } from './ui';

export function CountrySelect({ value, onChange, invalid, allowEmpty, emptyLabel }: { value: string; onChange: (v: string) => void; invalid?: boolean; allowEmpty?: boolean; emptyLabel?: string }) {
  const ref = useReference();
  return (
    <Select value={value} onChange={(e) => onChange(e.target.value)} invalid={invalid}>
      <option value="" disabled={!allowEmpty}>
        {emptyLabel ?? t('Select country…')}
      </option>
      {ref.data?.countries.map((c) => (
        <option key={c.code} value={c.code}>
          {currentLanguage() === 'ar' ? countryName(c.code, c.name) : c.name}
        </option>
      ))}
    </Select>
  );
}
